import { useEffect } from "react";

/**
 * Client-side page metadata. Sets <title>, meta description and canonical
 * URL per route. Falls back to the values set in public/index.html when
 * arguments are omitted.
 */
export default function usePageMeta({ title, description, canonical }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);

      const og = document.querySelector('meta[property="og:description"]');
      if (og) og.setAttribute("content", description);

      const tw = document.querySelector('meta[name="twitter:description"]');
      if (tw) tw.setAttribute("content", description);
    }

    if (title) {
      const ogT = document.querySelector('meta[property="og:title"]');
      if (ogT) ogT.setAttribute("content", title);
      const twT = document.querySelector('meta[name="twitter:title"]');
      if (twT) twT.setAttribute("content", title);
    }

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);

      const ogU = document.querySelector('meta[property="og:url"]');
      if (ogU) ogU.setAttribute("content", canonical);
    }
  }, [title, description, canonical]);
}
